import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useApp } from '../../context/AppContext';
import AdminLayout from '../../components/AdminLayout';
import AdminOverview from './AdminOverview';
import PrisonManagement from './PrisonManagement';
import SystemReports from './SystemReports';

function AdminDashboard() {
  const { user } = useApp();

  if (!user || user.type !== 'admin') {
    return <div>Access denied</div>;
  }

  return (
    <AdminLayout>
      <Routes>
        <Route path="/" element={<AdminOverview />} />
        <Route path="/prisons" element={<PrisonManagement />} />
        <Route path="/reports" element={<SystemReports />} />
      </Routes>
    </AdminLayout>
  );
}

export default AdminDashboard;